import { RgAffectsGeometry as M } from "@project-rouge/rg-core";
import { Vector3 as r, ExtrudeGeometry as u, Matrix4 as a, BoxGeometry as P } from "three";
import { differencePolygons2D as w } from "../../geometry-utils/clipper-utils/index2.js";
import { createPolygon as x } from "./index3.js";
import { createShape as i } from "./index4.js";
import { setColor as z } from "./index5.js";
function I(t) {
  const n = new r().fromArray(t.size), p = new r().fromArray(t.anchor);
  let e;
  const c = t.children.filter((o) => M[t.type].includes(o.type));
  if (c.length) {
    const o = x(t), m = [], y = [];
    for (const h of c) {
      const s = x(h, new r().fromArray(h.pos), !0), d = w(s, [o])[0];
      if (d && d.length)
        m.push(s);
      else {
        const A = i(s);
        y.push(A);
      }
    }
    const g = w(o, m)[0], f = i(g);
    f.holes.push(...y), e = new u(f, {
      depth: n.z,
      bevelEnabled: !1
    }), e.applyMatrix4(new a().makeTranslation(0, 0, -p.z * n.z));
  } else if (t.data && t.data.polygon) {
    const o = i(t.data.polygon);
    e = new u(o, {
      depth: n.y,
      bevelEnabled: !1
    }), e.applyMatrix4(new a().makeRotationX(Math.PI * 0.5)), e.applyMatrix4(new a().makeTranslation(0, n.y, 0));
  } else {
    e = new P(...n.toArray());
    const o = new r(0.5, 0.5, 0.5).sub(p).multiply(n);
    e.applyMatrix4(new a().makeTranslation(...o.toArray()));
  }
  e.name = t.name, z(e, t.color, t.alpha);
  let l;
  return e.index !== null ? (l = e.toNonIndexed(), e.dispose()) : l = e, l;
}
export {
  I as createGeometry
};
//# sourceMappingURL=index2.js.map
